export default "__VITE_ASSET__B844UW4Q__"